import React, { useState, useEffect } from 'react';
import warning_icon from '../../../assets/icons/WarningCircle.svg';
import { t } from 'i18next';

const TextInput = ({
    isRequired,
    onInputChange,
    isSubmitted,
    errorText,
    labelText,
    multiline = false,
    maxLength = Infinity,
    rows,
    placeholder,
    type = 'text',
    storageKey,
    value
}) => {
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        const storedValue = localStorage.getItem(storageKey) || '';
        setInputValue(storedValue);
    }, [storageKey]);

    useEffect(() => {
        if (value !== undefined) {
            setInputValue(value);
        }
    }, [value]);

    const handleInputChange = (e) => {
        const value = e.target.value;

        if (maxLength !== Infinity && value.length > maxLength) {
            return;
        }

        localStorage.setItem(storageKey, value);
        setInputValue(value);

        if (isRequired && value.trim() === '') {
            setError(true);
        } else {
            setError(false);
        }

        onInputChange(value);
    };

    return (
        <div className="flex flex-col w-full">
            <div className="flex justify-between items-center mb-1">
                <label className="text-gray-800 font-bold text-base">{labelText}</label>
                {maxLength !== Infinity && (
                    <span className="text-sm font-medium text-gray-500">
                        {t('charactersLeft')} {maxLength - inputValue.length}
                    </span>
                )}
            </div>

            <div className="flex justify-between items-center mb-1">
                {isRequired && isSubmitted && !inputValue && (
                    <>
                        <span className="text-red-500 text-sm">{errorText}</span>
                        <img src={warning_icon} alt='warning' className="ml-2 w-5 h-5"/>
                    </>
                )}
            </div>

            <div className={`w-full ${error ? 'border-red-500' : ''}`}>
                {multiline ? (
                    <textarea
                        placeholder={placeholder}
                        value={inputValue}
                        onChange={handleInputChange}
                        className="w-full bg-gray-100 text-gray-800 rounded-lg p-4 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 resize-none"
                        rows={rows}
                    />
                ) : (
                    <input
                        type={type}
                        placeholder={placeholder}
                        value={inputValue}
                        onChange={handleInputChange}
                        className="w-full bg-gray-100 text-gray-800 rounded-lg p-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500"
                    />
                )}
            </div>
        </div>
    );
};

export default TextInput;